import {
    makeStyles,
    Typography,
    Accordion,
    AccordionSummary,
    AccordionDetails,
} from "@material-ui/core"
import { ExpandMore } from "@material-ui/icons"
import { McK_ELECTRIC_BLUE } from "../../styles/colors"
import { McKSansLight } from "../../styles/fonts"
import { useTranslation } from "react-i18next";

const useStyles = makeStyles({
    heading: {
        fontFamily: McKSansLight,
        fontSize: '18px',
        color: McK_ELECTRIC_BLUE,
    },
    assetTagHint: {
        width: '290px',
        marginTop: '30px',
        marginBottom: '30px',
        '& img': {
            width: '250px',
            height: '150px',
        }
    }
})

const HiredateLabelHint = () => {
    const {t} = useTranslation('common');

    const classes = useStyles()
    return (
        <div className={classes.assetTagHint}>
            <Accordion>
                <AccordionSummary expandIcon={<ExpandMore />}>
                    <Typography className={classes.heading}>{t('get_hire_date.help.label')}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography>{t('get_hire_date.help.content')}</Typography>
                </AccordionDetails>
            </Accordion>
        </div>
    )
}

export default HiredateLabelHint

